module.exports = __webpack_public_path__ + "static/img/70027C_1_R_20221107_LC.cee54d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/70027C_1_R_20221107_LC.png
// module id = vIjf
// module chunks = 0